/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CheckEmailOptedOut200Response
 */
export interface CheckEmailOptedOut200Response {
    /**
     * Email is Opted Out
     * @type {boolean}
     * @memberof CheckEmailOptedOut200Response
     */
    data: boolean;
}

/**
 * Check if a given object implements the CheckEmailOptedOut200Response interface.
 */
export function instanceOfCheckEmailOptedOut200Response(value: object): value is CheckEmailOptedOut200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function CheckEmailOptedOut200ResponseFromJSON(json: any): CheckEmailOptedOut200Response {
    return CheckEmailOptedOut200ResponseFromJSONTyped(json, false);
}

export function CheckEmailOptedOut200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckEmailOptedOut200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'],
    };
}

export function CheckEmailOptedOut200ResponseToJSON(value?: CheckEmailOptedOut200Response | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': value['data'],
    };
}

